<script setup>
const props = defineProps({
  limit: {
    type: Number,
    default: 3
  }
})

</script>


<template>
  <PostList v-slot="{posts}" :limit="props.limit" root-path="/blog" >
    <div v-for="post in posts" :key="post.id" class="min-h-6 my-1">
      <ArticleLink :article="post" />
    </div>
  </PostList>
</template>